import { Product } from "../models"
import { ListResponse, Api } from "@/api"

import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"
import * as $ from "jquery"

@Component({ name: "ProductCarousel" })
export default class ProductCarousel extends Vue {
  featuredProductsListResponse: ListResponse<Product> | null = null
  swiped = false

  @Prop()
  requestOptions!: { [key: string]: string }

  mounted() {
    this.reloadFeaturedProducts()
  }

  async reloadFeaturedProducts() {
    const api = Api.createFromEnv()

    this.featuredProductsListResponse = await api
      .getList<Product>("products", this.requestOptions)
      .catch(error => {
        console.error(error)

        return null
      })

    window.setTimeout(this.setupCarousel, 1000)
  }

  setupCarousel() {
    $(this.$refs["carousel"]).carousel({
      ride: true,
    })

    $(this.$refs["carousel"]).swipe({
      swipe: (_: any, direction: string) => {
        const carousel = this.$refs["carousel"]

        if (direction == "left") {
          $(carousel).carousel("next")
          this.swiped = true
        } else if (direction == "right") {
          $(carousel).carousel("prev")
          this.swiped = true
        }
      },
      allowPageScroll: "vertical",
    })
  }

  @Watch("requestOptions")
  onRequestOptionsChange() {
    this.reloadFeaturedProducts()
  }

  onViewDetailClick(product: Product) {
    if (this.swiped === false) {
      this.$router
        .push({
          path: "products",
          query: { ...this.$route.query, detailProductId: product._id },
        })
        .catch(() => {})
    } else {
      this.swiped = false
    }
  }

  onActivatePreviousItemClick() {
    $("#productCarousel").carousel("prev")
  }

  onActivateNextItemClick() {
    $("#productCarousel").carousel("next")
  }
}
